import ProjectTopBar from "@/components/ProjectTopBar";
import Seo from "@/components/Seo";

/**
 * MockupFrame — affiche un vrai site client (maquette) en plein écran
 * via une iframe, avec la barre de retour au portfolio par-dessus.
 * Les fichiers sont servis depuis /public/mockups/.
 */
export default function MockupFrame({ src, title }) {
  return (
    <>
      <Seo
        title={title}
        description="Concept de site réalisé par ML. Agence Web — exemple de réalisation présenté dans le portfolio."
      />
      <ProjectTopBar />
      <div className="fixed inset-0 z-0 bg-black">
        <iframe
          src={src}
          title={title}
          className="w-full h-full border-0"
          loading="eager"
        />
      </div>
    </>
  );
}
